<template>
  <div class="page-container">
    <AppSidebar />

    <div class="main-content">
      <div class="static-page">
        <div class="page-header">
          <h1>隐私协议</h1>
        </div>

        <div class="content-container">
          <div class="content-text">
            <h2>一、信息收集</h2>
            <p>我们会收集您在使用本网站服务时主动提供的信息，包括但不限于：</p>
            <ul>
              <li>注册账号时提供的用户名、手机号、电子邮箱等基本信息</li>
              <li>使用服务过程中产生的浏览记录、阅读偏好等行为数据</li>
              <li>充值、购买会员等交易信息</li>
            </ul>

            <h2>二、信息使用</h2>
            <p>我们收集的信息将用于以下目的：</p>
            <ul>
              <li>为您提供更好的个性化服务和内容推荐</li>
              <li>处理您的订单和交易请求</li>
              <li>改进我们的产品和服务质量</li>
              <li>保障网站安全，防止欺诈和违规行为</li>
              <li>根据法律法规要求履行相关义务</li>
            </ul>

            <h2>三、信息保护</h2>
            <p>我们非常重视您的个人信息安全，采取以下措施保护您的信息：</p>
            <ul>
              <li>使用加密技术保护数据传输和存储</li>
              <li>建立严格的数据访问权限控制机制</li>
              <li>定期进行安全审计和漏洞检测</li>
              <li>对员工进行数据安全培训</li>
            </ul>

            <h2>四、信息共享</h2>
            <p>未经您的同意，我们不会向第三方共享、出售或出租您的个人信息，除非：</p>
            <ul>
              <li>经您明确同意或授权</li>
              <li>根据法律法规或政府部门要求</li>
              <li>为维护网站安全和合法权益所必需</li>
              <li>与我们的关联公司共享，但仅限于提供服务所必需</li>
            </ul>

            <h2>五、Cookie 使用</h2>
            <p>我们使用 Cookie 和类似技术来提升用户体验：</p>
            <ul>
              <li>记录您的登录状态和偏好设置</li>
              <li>分析网站访问情况，优化页面性能</li>
              <li>您可以通过浏览器设置管理或禁用 Cookie</li>
            </ul>

            <h2>六、未成年人保护</h2>
            <p>我们重视未成年人的个人信息保护：</p>
            <ul>
              <li>如果您是未成年人，请在监护人陪同下使用本网站</li>
              <li>监护人应当正确引导未成年人使用网络服务</li>
              <li>我们不会故意收集未成年人的个人信息</li>
            </ul>

            <h2>七、隐私政策变更</h2>
            <p>我们可能会不时更新本隐私政策。重大变更时，我们会通过网站公告或其他方式通知您。</p>

            <h2>八、联系我们</h2>
            <p>如果您对本隐私政策有任何疑问或建议，请通过以下方式联系我们：</p>
            <ul>
              <li>电话：13641239621</li>
              <li>邮箱：wudongjian@huashi.tv</li>
              <li>地址：湖北省武汉市洪山区雄楚大街452号保利蓝海郡G6栋1单元20层3室-2</li>
            </ul>

            <p class="update-time">最后更新时间：2026年6月12日</p>
          </div>
        </div>
      </div>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppSidebar from '@/components/layout/Sidebar.vue';
import AppFooter from '@/components/layout/Footer.vue';

export default {
  name: 'PrivacyPage',
  components: {
    AppSidebar,
    AppFooter
  },
  mounted() {
    document.title = '隐私协议 - 武汉天冉网络科技有限公司';
  }
};
</script>

<style scoped>
.page-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f6fa;
}

.main-content {
  flex: 1;
  margin-left: 200px;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.static-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  flex: 1;
  width: 100%;
}

.page-header {
  text-align: center;
  margin-bottom: 40px;
}

.page-header h1 {
  font-size: 30px;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
  position: relative;
  display: inline-block;
  padding-bottom: 15px;
}

.page-header h1:after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #ff6b81, #ff9eb6);
  border-radius: 3px;
}

.content-container {
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.08);
}

.content-text {
  line-height: 1.8;
  color: #444;
  font-size: 16px;
}

.content-text h2 {
  font-size: 22px;
  margin: 25px 0 15px;
  color: #333;
}

.content-text p {
  margin-bottom: 15px;
}

.content-text ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.content-text li {
  margin-bottom: 8px;
}

.update-time {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
  color: #999;
  font-size: 14px;
  text-align: center;
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }

  .static-page {
    padding: 20px 15px;
  }

  .content-container {
    padding: 20px;
  }
}
</style>
